import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@material-ui/core';
import { ArrowForward } from '@material-ui/icons';
import { toast } from 'react-toastify';

import AdminMenu from '../../../../../components/Admin/MenuDetalhes/AdminMenu';
import { createBatch, updateBatch } from '../../../../../services/certificateBatches';
import CompanyForm from '../components/CompanyForm';
import CertificateStep from './steps/CertificateStep';
import EmentaStep from './steps/EmentaStep';
import StudentsStep from './steps/StudentsStep';
import { MainContainer, ContentContainer, Title, Subtitle } from '../styles';
import { StepCard, StepsList, StepItem, StepNumber, ActionsRow } from './styles';

const STEPS = ['Empresa', 'Certificado', 'Ementa', 'Alunos'];

const INITIAL_CERTIFICATE = {
  title: '',
  id_curso: null,
  course_name: '',
  training_days: '',
  workload_hours: '',
  emission_date: null,
  signatures: [],
  include_ementa: true,
  is_english: false,
  hide_conclusion_date: false,
};

// Normaliza `signatures` (armazenado como objetos completos, pra exibição em
// chips) pro formato que o backend espera: array de ids.
const toSignatureIds = (signatures = []) =>
  signatures.map((signature) =>
    signature && typeof signature === 'object' ? signature.id : signature
  );

export default function BatchWizard() {
  const history = useHistory();
  const [step, setStep] = useState(0);
  const [company, setCompany] = useState(null);
  const [certificate, setCertificate] = useState(INITIAL_CERTIFICATE);
  const [courseLabel, setCourseLabel] = useState('');
  const [batchId, setBatchId] = useState(null);
  const [ementa, setEmenta] = useState([]);
  const [isSaving, setIsSaving] = useState(false);

  const persistBase = async (ementaData = ementa) => {
    const payload = {
      ...certificate,
      signatures: toSignatureIds(certificate.signatures),
      id_certificate_company: company.id,
      ementa: ementaData,
    };

    if (batchId) {
      await updateBatch(batchId, payload);
      return batchId;
    }

    const { data } = await createBatch(payload);
    setBatchId(data.id);
    return data.id;
  };

  const handleCertificateNext = async () => {
    setIsSaving(true);
    try {
      await persistBase();
      setStep(2);
    } catch (error) {
      toast.error('Não foi possível salvar a turma. Confira os dados e tente novamente.');
    } finally {
      setIsSaving(false);
    }
  };

  const handleEmentaNext = async (finalEmenta) => {
    setIsSaving(true);
    try {
      setEmenta(finalEmenta);
      await persistBase(finalEmenta);
      setStep(3);
    } catch (error) {
      toast.error('Não foi possível salvar a ementa. Tente novamente.');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <MainContainer>
      <AdminMenu />
      <ContentContainer>
        <Title>Nova turma</Title>
        <Subtitle>Certificados In-Company</Subtitle>

        <StepsList>
          {STEPS.map((label, i) => (
            <StepItem key={label} isActive={i === step}>
              <StepNumber isCurrentOrDone={i <= step}>{i + 1}</StepNumber>
              {label}
            </StepItem>
          ))}
        </StepsList>

        <StepCard>
          {step === 0 && (
            <>
              <CompanyForm value={company} onChange={setCompany} />
              <ActionsRow>
                <span />
                <Button
                  type="button"
                  variant="contained"
                  color="primary"
                  endIcon={<ArrowForward />}
                  disabled={!company}
                  onClick={() => setStep(1)}
                >
                  Avançar
                </Button>
              </ActionsRow>
            </>
          )}

          {step === 1 && (
            <CertificateStep
              value={certificate}
              onChange={setCertificate}
              courseLabel={courseLabel}
              onCourseLabelChange={setCourseLabel}
              onBack={() => setStep(0)}
              onNext={handleCertificateNext}
              isSaving={isSaving}
            />
          )}

          {step === 2 && (
            <EmentaStep
              value={ementa}
              onChange={setEmenta}
              onBack={() => setStep(1)}
              onNext={handleEmentaNext}
              isSaving={isSaving}
              includeEmenta={certificate.include_ementa}
            />
          )}

          {step === 3 && (
            <StudentsStep
              batchId={batchId}
              onBack={() => setStep(2)}
              onDone={() => history.push(`/admin/certificados/turmas/${batchId}`)}
            />
          )}
        </StepCard>
      </ContentContainer>
    </MainContainer>
  );
}
